import script from "./SeedRelatorioDetalhe.vue?vue&type=script&setup=true&lang=js"
export * from "./SeedRelatorioDetalhe.vue?vue&type=script&setup=true&lang=js"

import "./SeedRelatorioDetalhe.vue?vue&type=style&index=0&id=0ba656bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ba656bc"]])

export default __exports__